import React from 'react';

export const Logo = ({ url, className, alt }) => (
    <div className="logoWrapper">
        <img className={`logo ${className}`} src={url} alt={alt} />
    </div>
);

export default Logo;
